setTimeout(()=>{
  let buttonsSize = document.querySelectorAll('variant-selection .options-selection__option-values .options-selection__option-value');
  buttonsSize.forEach(button => {
    
    let ifDisabled = button.querySelector('.options-selection__option-value-input').hasAttribute('disabled');

    if(ifDisabled){
      button.setAttribute('disabled', '');
    } else {
      button.addEventListener('click', () => {
        removeClassArray(buttonsSize, 'options-selection__option-value--selected');
        button.classList.add('options-selection__option-value--selected');
      })
    }
  });

  function removeClassArray(array, className) {
    array.forEach(element => {
      element.classList.remove(`${className}`);
    });
  }
},2000)
